import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { Hostage } from '../types';
import '../../style/HostageList.css';
import {TextField, Container, Box, Typography} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import {useTranslation} from 'react-i18next';
import TitlebarImageList from "../TitlebarImageList";

interface HostageListProps {
  hostages: Hostage[];
}

const HostageList: React.FC<HostageListProps> = ({ hostages }) => {
  const {t, i18n} = useTranslation();
  const { user } = useUser();

  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const filteredItems = (hostages || []).filter(hostage =>
    hostage[i18n.language as "en" | "he"].name_with_title?.toLowerCase().includes(searchQuery?.toLowerCase())
  );

  const handleItemClick = (id: string) => {
    navigate(`/hostage/${id}`);
  };

  if (!user) {
    return <div>טוען את הדף...</div>;
  }

  return (
    <div>
      <Container maxWidth="sm" 
      className='hostage-list-container'
      sx={{padding: '8px'}}>
        <Typography 
          variant="h4" 
          component="h1" 
          className='header-title'>
          {t('hostageList.header.title')}
        </Typography>
        <Typography 
          variant="subtitle1" 
          component="h2"
          className='header-subtitle'>
          {t('hostageList.header.subTitle')}
        </Typography>
        <Box className='hostage-list-box'>
          <TextField
            fullWidth
            placeholder={t('hostageList.nameSearch')}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            variant="outlined"
            sx={{
              '& fieldset': {
                borderRadius: '8px',
                border: '1px solid #E0E0E0'
              },
              '& .MuiInputBase-input': {
                textAlign: 'right',
                '&::placeholder': {
                  color: 'black',
                  opacity: 1,
                },
              },
            }}
          />
          <SearchIcon className='hostage-list-search'

          />
        </Box>

        <TitlebarImageList
            hostages={filteredItems}
            onItemClick={handleItemClick}
        />
      </Container>
    </div>
  );
};

export default HostageList;
